'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class LocationItem
 * Displays a button for triggering an action in
 * the location menu.
 * @param {function} onClick - the feature to trigger when clicked.
 * @param {string} text - the text to display on the button.
 * @param {string} icon(optional)- the name of the icon to display with the text.
 */
var FeatureItem = function (_Component) {
  _inherits(FeatureItem, _Component);

  function FeatureItem() {
    _classCallCheck(this, FeatureItem);

    return _possibleConstructorReturn(this, (FeatureItem.__proto__ || Object.getPrototypeOf(FeatureItem)).apply(this, arguments));
  }

  _createClass(FeatureItem, [{
    key: 'render',

    /** @function render
      * Renders the location item component
      */
    value: function render() {
      return _react2.default.createElement(
        'button',
        { onClick: this.props.onClick },
        _react2.default.createElement(_reactFontawesome2.default, { name: this.props.icon }),
        this.props.text
      );
    }
  }]);

  return FeatureItem;
}(_react.Component);

exports.default = FeatureItem;


FeatureItem.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  text: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/navigation/feature-item.js
// module id = 1364
// module chunks = 0